export default "__VITE_ASSET__CIfzAdlo__"